<script>
import { Pie } from 'vue-chartjs'

export default {
  name: "PieChart",
  extends: Pie,
  props: {
    chartData: Object,
    options: Object
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
